import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import {
  IntuneEditFormAccordion,
  IntuneEditFormAccordionItem,
} from '../../intune/intune_common/IntuneEditFormAccordion'
import InputGroup from './InputGroup'
import { getVisiblePolicyAccordionSections } from './policyAccordionSections'

export const POLICY_FRAME_LAYOUT = {
  ACCORDION: 'accordion',
  FLAT: 'flat',
}

const propTypes = {
  /**
   * callback to decide if input should be displayed or not
   * If return true, input is displayed
   */
  displayInput: PropTypes.func,
  /**
   * Function to render input. Should return a react node. Params: input
   */
  renderInput: PropTypes.func.isRequired,
  /**
   * Optional renderer for content displayed next to the input label
   */
  renderLabelAction: PropTypes.func,
  /**
   * `flat` (default) for policy view/edit; `accordion` for template create/edit
   */
  layout: PropTypes.oneOf(Object.values(POLICY_FRAME_LAYOUT)),
}

function FormattedPolicyFrame(props) {
  const {
    displayInput = () => true,
    renderInput,
    renderLabelAction = () => null,
    layout = POLICY_FRAME_LAYOUT.FLAT,
  } = props ?? {}

  const visibleSections = useMemo(() => getVisiblePolicyAccordionSections(displayInput), [displayInput])
  const accordionKey = visibleSections.map((section) => section.sectionId).join('|')

  if (layout === POLICY_FRAME_LAYOUT.FLAT) {
    return (
      <>
        {visibleSections.map((section) => (
          <InputGroup
            key={section.sectionId}
            groupTitle={section.titleMessageId}
            inputs={section.inputs}
            displayInput={displayInput}
            renderInput={renderInput}
            renderLabelAction={renderLabelAction}
          />
        ))}
      </>
    )
  }

  return (
    <IntuneEditFormAccordion key={accordionKey || 'empty'}>
      {visibleSections.map((section) => (
        <IntuneEditFormAccordionItem
          key={section.sectionId}
          eventKey={section.sectionId}
          titleMessageId={section.titleMessageId}
        >
          <InputGroup
            inputs={section.inputs}
            displayInput={displayInput}
            renderInput={renderInput}
            renderLabelAction={renderLabelAction}
          />
        </IntuneEditFormAccordionItem>
      ))}
    </IntuneEditFormAccordion>
  )
}

FormattedPolicyFrame.propTypes = propTypes

export default FormattedPolicyFrame
